import { isDefined } from '@vueuse/core'

import { getRedirect } from '@/router/guards/common/getRedirect'

import store from '@/store'

/**
 * Check if the brand is in demo mode
 * @param {object} to Vue-router `to` object
 * @returns {object|undefined} a `next` object
 */
const checkDemoAccess = (to) => {
  const user = store.getters['session/user']

  const { meta = {} } = to

  const isDemoAccount = store.getters['core/brand/active/isDemoAccount']

  if (
    isDefined(isDemoAccount) &&
    isDemoAccount &&
    !meta.inDemo &&
    user.role !== 'pb:super'
  ) {
    return getRedirect(to, 'brand.home')
  }
}

export default checkDemoAccess
